import { lazy } from 'react';

const SESSION_KEY = 'chunk_reload_attempted';

sessionStorage.removeItem(SESSION_KEY);

const retryImport = (importFn, retries, delay) => {
  return importFn().catch((error) => {
    if (retries <= 0) throw error;
    return new Promise((resolve) => setTimeout(resolve, delay)).then(() =>
      retryImport(importFn, retries - 1, delay * 2)
    );
  });
};

const lazyWithRetry = (importFn, retries = 2, delay = 1000) => {
  return lazy(() =>
    retryImport(importFn, retries, delay).catch((error) => {
      if (!sessionStorage.getItem(SESSION_KEY)) {
        sessionStorage.setItem(SESSION_KEY, 'true');
        window.location.reload();
      }
      throw error;
    })
  );
};

export default lazyWithRetry;
